import { AccessType } from '@types';
import { DynamicQueryParams } from '@sonar-software/sonar-ts-types';

import { ApiEndpointHandler, createPostEndpoint } from '@sonar-software/sonar-http';

export type PostDataSecurityAccessComparisonExportRequest = DynamicQueryParams & {
	accessType?: Array<AccessType>;
	accessId?: Array<string>;
	objectId?: string;
};
export type PostDataSecurityAccessComparisonExportResponse = { id: number };

const postDataSecurityAccessComparisonExportStart = createPostEndpoint<
	PostDataSecurityAccessComparisonExportRequest,
	PostDataSecurityAccessComparisonExportResponse
>('/api/v3/core/exports/data-access/compare/export/start');


const postDataSecurityAccessComparisonFieldExportStart = createPostEndpoint<
	PostDataSecurityAccessComparisonExportRequest,
	PostDataSecurityAccessComparisonExportResponse
>(({ objectId }) => `/api/v3/core/exports/data-access/compare/object/${objectId}/export/start`);


export const postDataAccessComparisonExportStart: ApiEndpointHandler<
	PostDataSecurityAccessComparisonExportRequest,
	PostDataSecurityAccessComparisonExportResponse
> = (request, options) => {
	if (request.objectId) {
		return postDataSecurityAccessComparisonFieldExportStart(request, options);
	}

	return postDataSecurityAccessComparisonExportStart(request, options);
};
